<template>

  <div>

    <v-card class="ma-1" outlined>

      <v-card-title style="height: 64px">
        Politici
        <v-spacer/>
        <v-btn x-small fab depressed color="primary" @click="dialog=!dialog">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider class="mx-4"/>

      <v-card-text style="height: 247px; overflow-y: auto">

        <template v-if="!hotel.static.policies.check_in.start || !hotel.static.policies.check_in.end || !hotel.static.policies.check_out.start || !hotel.static.policies.check_out.end">
          <v-alert dark color="error">
            <v-row no-gutters align="center">
              <v-icon left>mdi-alert</v-icon>
              Politicile hotelului nu sunt complete.
            </v-row>
          </v-alert>
        </template>

        <template v-else>
          <v-row no-gutters class="ma-n1">
            <v-col cols="12" md="4">
              <v-card outlined class="pa-2 ma-1">
                <v-card-title class="subtitle-1 pa-0 ma-0">Cazare</v-card-title>
                <v-divider class="my-1"/>
                <v-card-text class="pa-0 ma-0">
                  <v-row no-gutters align="baseline">
                    <small class="mr-1">Check-In:</small>
                    <div v-once>{{hotel.static.policies.check_in.start}}</div>
                    <v-icon class="mx-1" x-small>mdi-arrow-right</v-icon>
                    {{hotel.static.policies.check_in.end}}
                  </v-row>
                  <v-row no-gutters align="baseline">
                    <small class="mr-1">Check-Out:</small>
                    {{hotel.static.policies.check_out.start}}
                    <v-icon class="mx-1" x-small>mdi-arrow-right</v-icon>
                    {{hotel.static.policies.check_out.end}}
                  </v-row>
                  <v-row no-gutters>
                    <small class="mr-1">Zile de Weekend:</small>
                    {{weekdays[hotel.static.policies.weekend[0]]}}, {{weekdays[hotel.static.policies.weekend[1]]}}
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card outlined class="pa-2 ma-1">
                <v-card-title class="subtitle-1 pa-0 ma-0">Copii</v-card-title>
                <v-divider class="my-1"/>
                <v-card-text class="pa-0 ma-0">
                  <v-row no-gutters align="baseline">
                    <small class="mr-1">Infanti (0-2 ani): </small>
                    <template v-if="hotel.static.policies.children.infants.active">
                      {{hotel.static.policies.children.infants.pricing.value}}{{hotel.static.policies.children.infants.pricing.type === 'percent' ? '%' : ''}}
                      {{hotel.static.policies.children.infants.pricing.type === 'percent' ? 'din pretul de adult.' : hotel.static.policies.payments.currency}}
                    </template>
                    <template v-else>
                      N/A
                    </template>
                  </v-row>
                  <v-row no-gutters align="baseline">
                    <small class="mr-1">Copii (2-7 ani): </small>
                    <template v-if="hotel.static.policies.children.infants.active">
                      {{hotel.static.policies.children.small.pricing.value}}{{hotel.static.policies.children.small.pricing.type === 'percent' ? '%' : ''}}
                      {{hotel.static.policies.children.small.pricing.type === 'percent' ? 'din pretul de adult.' : hotel.static.policies.payments.currency}}
                    </template>
                    <template v-else>
                      N/A
                    </template>
                  </v-row>
                  <v-row no-gutters align="baseline">
                    <small class="mr-1">Adolescenti (7-17 ani): </small>
                    <template v-if="hotel.static.policies.children.infants.active">
                      {{hotel.static.policies.children.big.pricing.value}}{{hotel.static.policies.children.big.pricing.type === 'percent' ? '%' : ''}}
                      {{hotel.static.policies.children.big.pricing.type === 'percent' ? 'din pretul de adult.' : hotel.static.policies.payments.currency}}
                    </template>
                    <template v-else>
                      N/A
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" class="d-flex flex-column">
              <v-card outlined class="pa-2 ma-1 flex">
                <v-card-title class="subtitle-1 pa-0 ma-0">Monede și plăti</v-card-title>
                <v-divider class="my-1"/>
                <v-card-text class="pa-0 ma-0">
                  <v-row no-gutters align="baseline">
                    <small class="mr-1">Moneda implicita:</small>
                    {{hotel.static.policies.payments.currency}}
                  </v-row>
                  <v-row no-gutters align="baseline">
                    <small class="mr-1">Monede acceptate:</small>
                    <template v-for="accepted_currency in hotel.static.policies.payments.accepted_currencies">
                      <template>{{accepted_currency}} </template>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="8">
              <v-card outlined class="pa-2 ma-1">
                <v-card-title class="subtitle-1 pa-0 ma-0">Paturi suplimentare</v-card-title>
                <v-divider class="my-1"/>
                <v-card-text class="pa-0 ma-0">
                  <v-row no-gutters>
                    <template v-if="hotel.static.policies.extrabeds.active">
                      <small class="mr-1">Pret: </small>
                      {{hotel.static.policies.extrabeds.pricing.type === 'flat'
                      ? hotel.static.policies.extrabeds.pricing.value + ' ' + hotel.static.policies.payments.currency
                      : hotel.static.policies.extrabeds.pricing.value + '%'}}
                    </template>
                    <template v-else>
                      Aceasta unitate nu pune la dispozitie paturi suplimentare.
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card outlined class="pa-2 ma-1">
                <v-card-title class="subtitle-1 pa-0 ma-0">Single stay</v-card-title>
                <v-divider class="my-1"/>
                <v-card-text class="pa-0 ma-0">
                  <v-row no-gutters align="baseline">
                    <template v-if="hotel.static.policies.single_stay.active">
                      <small class="mr-1">Pret: </small>
                      {{
                      hotel.static.policies.single_stay.pricing.type === 'flat'
                      ? hotel.static.policies.single_stay.pricing.value + ' ' + hotel.static.policies.payments.currency
                      : hotel.static.policies.single_stay.pricing.value + '%'
                      }}
                    </template>
                    <template v-else>
                      Aceasta unitate nu are regim single stay.
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>

            </v-col>
          </v-row>
        </template>

      </v-card-text>

    </v-card>

    <v-dialog v-model="dialog" width="960">
      <v-card>

        <v-toolbar class="primary white--text" flat dark>
          <v-toolbar-title>Politici</v-toolbar-title>
          <v-spacer/>
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-3">
          <v-row no-gutters>

            <v-col cols="12">
              <div class="subtitle-1 font-weight-bold ma-1 mt-0">
                Ore de Check-In / Out:
              </div>
            </v-col>

            <v-col cols="6">
              <v-card class="ma-1" outlined>
                <v-card-text class="pa-1">
                  <div class="ma-2 mt-1">Check-In:</div>

                  <v-menu offset-y max-width="290" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="hotel.static.policies.check_in.start" v-on="on" class="ma-2" label="De la" readonly outlined dense hide-details/>
                    </template>
                    <v-time-picker v-model="hotel.static.policies.check_in.start" ampm-in-title/>
                  </v-menu>

                  <v-menu offset-y max-width="290" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="hotel.static.policies.check_in.end" v-on="on" class="ma-2" label="Pana la" readonly outlined dense hide-details/>
                    </template>
                    <v-time-picker v-model="hotel.static.policies.check_in.end" ampm-in-title/>
                  </v-menu>

                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card class="ma-1" outlined>
                <v-card-text class="pa-1">
                  <div class="ma-2 mt-1">Check-Out:</div>

                  <v-menu offset-y max-width="290" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="hotel.static.policies.check_out.start" v-on="on" class="ma-2" label="De la" readonly outlined dense hide-details/>
                    </template>
                    <v-time-picker v-model="hotel.static.policies.check_out.start" ampm-in-title/>
                  </v-menu>

                  <v-menu offset-y max-width="290" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="hotel.static.policies.check_out.end" v-on="on" class="ma-2" label="Pana la" readonly outlined dense hide-details/>
                    </template>
                    <v-time-picker v-model="hotel.static.policies.check_out.end" ampm-in-title/>
                  </v-menu>

                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <div class="subtitle-1 font-weight-bold ma-1">Zile Weekend:</div>
            </v-col>
            <v-col cols="12">
              <v-item-group v-model="hotel.static.policies.weekend" multiple>
                <v-item v-for="day in weekdays" v-slot:default="{ active, toggle }" :key="day">
                  <v-btn depressed small :color="active ? 'primary' : 'grey lighten-2'" class="ma-1" @click="toggle">{{day}}</v-btn>
                </v-item>
              </v-item-group>
            </v-col>

            <v-col cols="12">
              <div class="subtitle-1 font-weight-bold ma-1">Modalități de plată acceptate:</div>
            </v-col>
            <v-col cols="6">
              <v-select v-model="hotel.static.policies.payments.currency" :items="currencies" class="ma-1" label="Moneda implicita" outlined dense hide-details/>
            </v-col>
            <v-col cols="6">
              <v-autocomplete v-model="hotel.static.policies.payments.accepted_currencies" :items="currencies" class="ma-1" label="Valute acceptate" multiple outlined dense hide-details>
                <template v-slot:selection="data">
                  <v-chip v-bind="data.attrs" :input-value="data.selected" small>
                    {{data.item}}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete v-model="hotel.static.policies.payments.accepted_credit_cards" :items="cards" class="ma-1" label="Carduri acceptate" multiple outlined dense hide-details>
                <template v-slot:selection="data">
                  <v-chip v-bind="data.attrs" :input-value="data.selected" small>
                    {{data.item.text}}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>


            <v-col cols="12">
              <div class="subtitle-1 font-weight-bold ma-1">Politici copii:</div>
            </v-col>
            <v-col cols="12">
              <v-checkbox v-model="hotel.static.policies.children.active" class="ma-0 pa-0" color="primary" label="Această unitate acceptă copii în cameră cu adulți" hide-details/>
            </v-col>

            <template v-if="hotel.static.policies.children.active">

              <v-col cols="12">
                <v-checkbox v-model="hotel.static.policies.children.infants.active" class="ma-0 pa-0" color="primary" label="Infanti" hide-details/>
              </v-col>
              <template v-if="hotel.static.policies.children.infants.active">
                <v-col cols="6">
                  <v-card class="ma-1" outlined>
                    <v-card-text class="pa-1">
                      <div class="ma-2 mt-1">Grupe de varsta</div>
                      <v-text-field v-model="hotel.static.policies.children.infants.ages.from" label="Varsta de la" class="ma-2" type="number" :value="0" readonly dense outlined hide-details/>
                      <v-text-field v-model="hotel.static.policies.children.infants.ages.to" label="Varsta pana la" class="ma-2" type="number" dense outlined hide-details/>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card class="ma-1" outlined>
                    <v-card-text class="pa-1">
                      <div class="ma-2 mt-1">Tarif paturi suplimentare</div>
                      <v-text-field v-model="hotel.static.policies.children.infants.pricing.value" label="Tarif" class="ma-2" dense outlined hide-details/>
                      <v-select v-model="hotel.static.policies.children.infants.pricing.type" :items="[{value: 'flat', text: 'Valoare fixa'}, {value: 'percent', text: 'Valoare % din pret adult'}]" label="Tip tarif" class="ma-2" dense outlined hide-details/>
                    </v-card-text>
                  </v-card>
                </v-col>
              </template>


              <v-col cols="12">
                <v-checkbox v-model="hotel.static.policies.children.small.active" class="ma-0 pa-0" color="primary" label="Copii care ocupa un loc comun in pat cu parintii" hide-details/>
              </v-col>
              <template v-if="hotel.static.policies.children.small.active">
                <v-col cols="6">
                  <v-card class="ma-1" outlined>
                    <v-card-text class="pa-1">
                      <div class="ma-2 mt-1">Grupe de varsta</div>
                      <v-text-field v-model="hotel.static.policies.children.small.ages.from" label="Varsta de la" class="ma-2" type="number" dense outlined hide-details/>
                      <v-text-field v-model="hotel.static.policies.children.small.ages.to" label="Varsta pana la" class="ma-2" type="number" dense outlined hide-details/>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card class="ma-1" outlined>
                    <v-card-text class="pa-1">
                      <div class="ma-2 mt-1">Tarif paturi suplimentare</div>
                      <v-text-field v-model="hotel.static.policies.children.small.pricing.value" label="Tarif" class="ma-2" type="number" dense outlined hide-details/>
                      <v-select v-model="hotel.static.policies.children.small.pricing.type" :items="[{value: 'flat', text: 'Valoare fixa'}, {value: 'percent', text: 'Valoare % din pret adult'}]" label="Tip tarif" class="ma-2" dense outlined hide-details/>
                    </v-card-text>
                  </v-card>
                </v-col>
              </template>


              <v-col cols="12">
                <v-checkbox v-model="hotel.static.policies.children.big.active" class="ma-0 pa-0" color="primary" label="Copii care ocupa un loc distinct in pat fata de parinti" hide-details/>
              </v-col>
              <template v-if="hotel.static.policies.children.big.active">
                <v-col cols="6">
                  <v-card class="ma-1" outlined>
                    <v-card-text class="pa-1">
                      <div class="ma-2 mt-1">Grupe de varsta</div>
                      <v-text-field v-model="hotel.static.policies.children.big.ages.from" label="Varsta de la" class="ma-2" type="number" dense outlined hide-details/>
                      <v-text-field v-model="hotel.static.policies.children.big.ages.to" label="Varsta pana la" class="ma-2" type="number" dense outlined hide-details/>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card class="ma-1" outlined>
                    <v-card-text class="pa-1">
                      <div class="ma-2 mt-1">Tarif paturi suplimentare</div>
                      <v-text-field v-model="hotel.static.policies.children.big.pricing.value" label="Tarif" class="ma-2" type="number" dense outlined hide-details/>
                      <v-select v-model="hotel.static.policies.children.big.pricing.type" :items="[{value: 'flat', text: 'Valoare fixa'}, {value: 'percent', text: 'Valoare % din pret adult'}]" label="Tip tarif" class="ma-2" dense outlined hide-details/>
                    </v-card-text>
                  </v-card>
                </v-col>
              </template>
            </template>

            <v-col cols="12">
              <div class="subtitle-1 font-weight-bold ma-1">Paturi suplimentare si regim single:</div>
            </v-col>

            <v-col cols="12">
              <v-checkbox v-model="hotel.static.policies.extrabeds.active" class="ma-0 pa-0" color="primary" label="Aceasta unitate are paturi suplimentare" hide-details/>
            </v-col>
            <template v-if="hotel.static.policies.extrabeds.active">
              <v-col cols="12">
                <v-card class="ma-1" outlined>
                  <v-card-text class="pa-1">
                    <div class="ma-1">Tarif paturi suplimentare</div>
                    <v-row no-gutters>
                      <v-col cols="6">
                        <v-text-field v-model="hotel.static.policies.extrabeds.pricing.value" label="Tarif" class="ma-1" type="number" dense outlined hide-details/>
                      </v-col>
                      <v-col cols="6">
                        <v-select v-model="hotel.static.policies.extrabeds.pricing.type" :items="[{value: 'flat', text: 'Valoare fixa'}, {value: 'percent', text: 'Valoare % din pret adult'}]" label="Tip tarif" class="ma-1" dense outlined hide-details/>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </template>

            <v-col cols="12">
              <v-checkbox v-model="hotel.static.policies.single_stay.active" class="ma-0 pa-0" color="primary" label="Aceasta unitate are regim single stay" hide-details/>
            </v-col>
            <template v-if="hotel.static.policies.single_stay.active">
              <v-col cols="12">
                <v-card class="ma-1" outlined>
                  <v-card-text class="pa-1">
                    <div class="ma-1">Tarif single stay</div>
                    <v-row no-gutters>
                      <v-col cols="6">
                        <v-text-field v-model="hotel.static.policies.single_stay.pricing.value" label="Tarif" class="ma-1" type="number" dense outlined hide-details/>
                      </v-col>
                      <v-col cols="6">
                        <v-select v-model="hotel.static.policies.single_stay.pricing.type" :items="[{value: 'flat', text: 'Valoare fixa'}, {value: 'percent', text: 'Valoare % din pret camera'}]" label="Tip tarif" class="ma-1" dense outlined hide-details/>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </template>

            <v-col cols="12">
              <div class="subtitle-1 font-weight-bold ma-1">Termeni si conditii:</div>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="hotel.static.policies.terms_and_conditions.ro" class="ma-1" dense outlined hide-details/>
            </v-col>


          </v-row>
        </v-card-text>

        <v-divider class="mx-2"/>

        <v-card-actions>
          <v-btn color="primary" text @click="cancel">
            Anuleaza
          </v-btn>
          <v-spacer/>
          <v-btn color="primary" depressed @click="save">
            Salveaza
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </div>

</template>

<script>

  import conf_repository from '@/repositories/config-repository'

  export default {

    props: {
      hotel: Object
    },

    async created() {
      this.cards = await conf_repository.getCards();
    },

    data: () => ({
      dialog: false,
      weekdays: ['Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm', 'Dum'],
      currencies: ['RON', 'USD', 'EUR'],
      cards: []
    }),

    methods: {
      save: function () {
        this.dialog = false;
        this.$emit('save');
      },

      cancel() {
        this.$emit('cancel');
        this.dialog = false;
      }
    }

  }
</script>